module.exports = __webpack_public_path__ + "img/icone-multiedro-white.2724df2e.png";